import { Icon } from '@eventbrite/eds-icon';
import { BoltFill } from '@eventbrite/eds-iconography';
import React from 'react';
import './promotedLabel.scss';

export const PromotedLabel = () => {
    return (
        <div className="eds-promoted-label--container">
            <Icon type={<BoltFill />} color="ui-blue" />
            <span className="eds-text-bl eds-promoted-label--text">
                Promoted
            </span>
        </div>
    );
};
